import React from 'react';
import { Button } from '@/components/ui/button';
import { LogIn } from 'lucide-react';

const LoginPage = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4 relative overflow-hidden noise-bg">
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: "url('https://images.pexels.com/photos/13808098/pexels-photo-13808098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')" }}
      />
      
      <div className="relative z-10 max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_kickbox-guard/artifacts/0qoeaod0_copy_EFC5F12B-4CDF-459A-BE8A-4BDC3F8667B9_Original.jpeg"
            alt="BKA Logo"
            className="h-32 w-auto"
          />
        </div>
        
        {/* Content */}
        <div className="text-center space-y-4">
          <h1 
            className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white font-heading"
            data-testid="login-title"
          >
            ACCESO
          </h1>
          <p className="text-base md:text-lg text-zinc-400 font-body">
            Sistema de Control de Acceso
          </p>
        </div>
        
        {/* Login Button */}
        <div className="flex justify-center">
          <Button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="bg-primary hover:bg-[#b20710] text-white rounded-sm font-bold uppercase tracking-wider h-12 px-8 shadow-[0_0_15px_rgba(229,9,20,0.3)] transition-all active:scale-95"
          >
            <LogIn className="mr-2 h-5 w-5" />
            INICIAR SESIÓN
          </Button>
        </div>
        
        <p className="text-center text-xs text-zinc-600 font-body">
          Bolivian Kickboxing Academy © 2026
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
